import { RequestInstance } from "../neighbors/types/OrderStatus";
import { formatDateWithTZ, userFacingDateTimeFormat } from "./timezone";

export const customDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';

export const capitalizeFirstLetter = (string: string): string => {
    if (typeof string !== 'string') return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getInitials = (firstName?: string, lastName?: string): string => {
    const first = (firstName || '').trim().charAt(0);
    const last = (lastName || '').trim().charAt(0);
    return `${first}${last}`.toUpperCase();
};

export const cart = "cart";

export const carouselCart = "carouselCart"

export const menuPage = "menuPage";

/** Displayed order # is the last 8 characters of the Mongo _id, not the OrderId grouping field. */
export const getOrderNumber = (id?: string): string => {
    if (!id) return '-';
    const str = String(id);
    return str.length > 8 ? str.slice(-8) : str;
};

export  const formatOrdersForTableView = (orders: RequestInstance[], facilityTimezone: string) => {
    return orders.map((order) => {
        return {
            ...order,
            OrderName: order.OrderName || '-',
            OrderId: order.OrderId || '-',
            DateTime: formatDateWithTZ(order.RequestedTime, userFacingDateTimeFormat, facilityTimezone),
            AcceptedByName: order.AcceptedByName || '-',
            Scheduled: order.ScheduledTime ? 'Yes' : 'No',
            _id: order._id,
        };
    });
};

